import * as React from "react";
import { UFUpdateControl, UpdateControl, UpdateImage } from "../common/communication.base";
import { NclWebView } from "../common/components.ncl";
import { K2ComponentState, withContext, WithContextPlacementProps, StyleHelper, AcquireControl } from "./k2hoc";

class _WebView extends React.PureComponent<WithContextPlacementProps, K2ComponentState<UpdateImage>> {
  static displayName = "K2WebView";
  private control: NclWebView;

  constructor(props: WithContextPlacementProps) {
    super(props);
    this.control = AcquireControl(this.props.controlUID, this.props.vrUID, (ctrl) => ctrl instanceof NclWebView) as NclWebView;
    this.state = { data: this.control.init(this) as UpdateImage, vcxVersion: -1 };
  }

  updateState(state: UpdateControl) {
    this.setState(() => {
      return { data: state as UpdateImage };
    });
  }

  updateVCX(vcxVersion: number) {
    this.setState({ vcxVersion: vcxVersion });
  }

  componentWillUnmount() {
    this.control.willUnMount(true);
    this.control = null;
  }

  render() {
    return (
      <div style={StyleHelper(this.control, this.props.style)}>
        {this.state.data.ObjectId && (
          <iframe
            src={this.state.data.ObjectId}
            style={{ border: "0", top: "0px", left: "0px", bottom: "0px", right: "0px", width: "100%", height: "100%" }}
            sandbox="allow-scripts allow-popups allow-modals allow-forms"
          />
        )}
      </div>
    );
  }
}

export const K2WebView = withContext(_WebView);
